import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReportMetadata, ReportSchedule } from '../models/report.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportScheduleService {
  // endpoint = 'http://localhost:58830/api/Report/';
  endpoint = environment.apiEndpoint + '/ReportSchedule/';
  reportScheduleData: ReportMetadata[];

  constructor(private http: HttpClient) {}

  getReportSchedule(): Observable<any> {
    //console.log('in ReportDashboardService');
    return this.http.get(this.endpoint + 'GetPostAuthorReportSchedules');
  }

  getReportScheduleById(Id: any): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportScheduleById?id=' + Id);
  }

  getReportSchedulesByYear(reportYear: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportSchedulesByYear?reportYear=' + reportYear);
  }

 replicateReportScheduleForYear(reportYear: number): Observable<any> {
    return this.http.get(this.endpoint + 'ReplicateReportScheduleForYear?reportYear=' + reportYear);
  }

  getReportSchedulesToRelease(reportYear: number, IsReleased: boolean): Observable<any> {
    return this.http.get(
      this.endpoint + 'GetReportSchedulesToRelease?reportYear=' + reportYear + '&isReleased=' + IsReleased
    );
  }

  saveReportSchedule(reportSchedule: any[]): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportSchedule;
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/CreateReportSchedules', body, {
      headers,
      observe: 'response'
    });
  }

  editReportSchedule(reportSchedule: any[]): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportSchedule;
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/EditReportSchedule', body, {
      headers,
      observe: 'response'
    });
  }

  createReportSchedule(reportSchedule: any[]): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportSchedule;
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/CreateReportSchedules', body, {
      headers,
      observe: 'response'
    });
  }
  // getReportScheduleToRelease(reportYear: number): Observable<any>{
  //     return this.http.get(this.endpoint + 'GetReportScheduleToRelease?reportYear=' + reportYear)
  // }
  releaseRecallReportSchedule(reportScheduleId: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportScheduleId;
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/ReleaseRecallReportSchedule', body, {
      headers,
      observe: 'response'
    });
  }

  deleteReportSchedule(Id: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = Id;
    return this.http.post(environment.apiEndpoint + '/ReportSchedule/DeleteReportSchedule?Id=' + Id, body, {
      headers,
      observe: 'response'
    });
  }

  updateReportScheduleById(Id: any, IsPublic: boolean, ReportDueDate:any,ProposedDueDate: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
     const body = [{ reportId: Id, isPublic: IsPublic, proposedDueDate: ProposedDueDate}];
    //  return this.http.post(environment.apiEndpoint + '/ReportSchedule/UpdateReportScheduleById' + body,
    //     { headers, observe: 'response' });
      return this.http.post(environment.apiEndpoint + '/ReportSchedule/UpdateReportScheduleById?reportId=' + Id +
                                          '&isPublic=' + IsPublic +
                                          '&reportDueDate=' + ReportDueDate +
                                          '&proposedDueDate=' + ProposedDueDate, body,
        { headers, observe: 'response' });
  }
}
